// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3185":"372a212cb12e1b0d","3515":"e563703cdea94558"}[chunkId] + ".css";
};